// @flow
import { IllegalArgumentException } from "../exceptions";

export type TemplateProps = {
  contextPath: string,
  html: string,
  head: Object,
  state: string,
  UUID: string,
};

/**
 */
const htmlpage = (props: TemplateProps): string => {
  if (props?.contextPath === undefined) {
    throw new IllegalArgumentException("Missing contextPath argument");
  }
  if (props.html === undefined) {
    throw new IllegalArgumentException("Missing html for server");
  }

  const { head = {} } = props;

  const template = `
  <!doctype html>
  <html ${head.htmlAttributes ? head.htmlAttributes.toString() : ""}>
    <head>
      <meta charset="utf-8" />
      ${Object.keys(head)
        .filter((key) => key !== "htmlAttributes")
        .map((key) => head[key].toString())
        .join("")}
      {CSSASSETS:<link rel="stylesheet" type="text/css" href="{CONTEXT_PATH}/{FILE}" />:CSSASSETS}
    </head>
    <body class="nojs">
      <div id="application">${props.html}</div>
      <div id="portal"></div>
      <script
        type="application/json"
        data-app-state="app-json"
        data-app-contextpath="{CONTEXT_PATH}"
        data-app-filepath="{FILEPATH}"
        data-app-nonce="${props.UUID ?? ""}">${props.state ?? ""}</script>
      {JSASSETS:<script src="{CONTEXT_PATH}/{FILE}"></script>:JSASSETS}
    </body>
  </html>
`;

  // It is important to replace the context afterwards,
  // the JSASSESTS and CSSASSETS parts act as a small template for all generated javascript and css files
  // these templates must be pure strings to make it possible to add the context path in all situations
  return template.replace(/{CONTEXT_PATH}/g, props.contextPath).trim();
};

export default htmlpage;
